<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <situacion-laboral-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import SituacionLaboralProvider from "../../../../providers/SituacionLaboralProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import SituacionLaboralForm from "../SituacionLaboralForm";
  
    

    export default {
        name: "SituacionLaboralUpdate",
        
        components: { SituacionLaboralForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.situacionLaboral.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    nombre: this.item.nombre
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    SituacionLaboralProvider.updateSituacionLaboral(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateSituacionLaboral)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

